<template>
  <van-icon class="tn-drag-icon" v-bind="$attrs" v-on="$listeners" @mousedown="mousedown" @touchstart="touchstart"/>
</template>
<script>
  export default {
    name: 'TnDragIcon',
    methods: {
      mousedown(ev) {
        let target = ev.target || ev.srcElement;
        let disX = ev.clientX - target.offsetLeft;
        let disY = ev.clientY - target.offsetTop;
        document.onmousemove = function (ev) {
          let l = ev.clientX - disX;
          let t = ev.clientY - disY;
          target.style.left = l + 'px';
          target.style.top = t + 'px';
        };
        document.onmouseup = function () {
          document.onmousemove = null;
          document.onmouseup = null;
        };
      },
      touchstart(ev) {
        let target = ev.target || ev.srcElement;
        let disX = ev.touches[0].clientX - target.offsetLeft;
        let disY = ev.touches[0].clientY - target.offsetTop;
        target.touchmove = function (ev) {
          ev.preventDefault();
          let l = ev.touches[0].clientX - disX;
          let t = ev.touches[0].clientY - disY;
          target.style.left = l + 'px';
          target.style.top = t + 'px';
        };
        target.touchend = function () {
          document.touchmove = null;
          document.touchend = null;
        };
      }
    }
  };
</script>
